export function IconSearchRefresh() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <circle cx="10.2" cy="10.2" r="5.4" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path d="m14.1 14.1 5.2 5.2" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M16.7 7.2a7.2 7.2 0 0 1-8.8 8.2" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M16.7 4.8v2.8h-2.7" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function IconImagePlus() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <rect x="3.4" y="5.2" width="13.4" height="13.6" rx="2.2" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="m5.8 15.4 3.1-3.4 2.3 2.2 2.1-2.6 3.1 3.8" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <circle cx="8.1" cy="9.2" r="1.1" fill="currentColor" />
      <path d="M18.6 14.2v5.2M16 16.8h5.2" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  )
}

export function IconLink() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M10.2 13.8a3.6 3.6 0 0 0 5.1 0l2.3-2.3a3.6 3.6 0 0 0-5.1-5.1L11.4 7.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M13.8 10.2a3.6 3.6 0 0 0-5.1 0L6.4 12.5a3.6 3.6 0 1 0 5.1 5.1l1.1-1.1" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  )
}

export function IconCameraCheck() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M8 7.2 9.3 5.7h5.4L16 7.2h3.2A1.8 1.8 0 0 1 21 9v8.2a1.8 1.8 0 0 1-1.8 1.8H4.8A1.8 1.8 0 0 1 3 17.2V9A1.8 1.8 0 0 1 4.8 7.2H8Z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="m8.8 13.2 2.1 2.1 4.4-4.6" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function IconCheck() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="m6.2 12.2 4 4.1 7.6-8.4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function IconClose() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M7 7l10 10M17 7 7 17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  )
}

export function IconPin() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M12 21s6.4-5.4 6.4-10.2A6.4 6.4 0 0 0 5.6 10.8C5.6 15.6 12 21 12 21Z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="10.6" r="2.1" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  )
}

export function IconPinOff() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M12 21s6.4-5.4 6.4-10.2A6.4 6.4 0 0 0 5.6 10.8C5.6 15.6 12 21 12 21Z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="m6 6 12 12" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
  )
}

export function IconTrash() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M5.5 7.2h13.1M9.2 7.2V5.6A1.4 1.4 0 0 1 10.6 4.2h2.8A1.4 1.4 0 0 1 14.8 5.6v1.6" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M8 7.2 8.7 19a1.5 1.5 0 0 0 1.5 1.4h3.6A1.5 1.5 0 0 0 15.3 19l.7-11.8" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  )
}

export function IconCameraRetake() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M8 7.2 9.3 5.7h5.4L16 7.2h3.2A1.8 1.8 0 0 1 21 9v8.2a1.8 1.8 0 0 1-1.8 1.8H4.8A1.8 1.8 0 0 1 3 17.2V9A1.8 1.8 0 0 1 4.8 7.2H8Z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="13.1" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path d="M17.8 5.2a4.6 4.6 0 0 1 3 3.8" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M19.2 3.8v2.6h2.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function IconEdit() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M4.6 16.8 16.2 5.2a1.8 1.8 0 0 1 2.5 0l.1.1a1.8 1.8 0 0 1 0 2.5L7.2 19.4H4.6v-2.6Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M14.4 6.8 17.2 9.6" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  )
}

export function IconCartPlus() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M4.2 6.2h2.1l1.4 9.2h9.6l1.8-6.4H7" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <circle cx="9.4" cy="18.4" r="1.2" fill="currentColor" />
      <circle cx="16.4" cy="18.4" r="1.2" fill="currentColor" />
      <path d="M17.6 4.8v4.4M15.4 7h4.4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  )
}

export function IconBarcode() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M4 6v12M7 6v12M9 6v12M12.5 6v12M15 6v12M18 6v12M20 6v12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  )
}

export function IconPriceTag() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path d="M4.8 12.8 12 5.6h6.4V12L11.2 19.2a1.6 1.6 0 0 1-2.3 0L4.8 15a1.6 1.6 0 0 1 0-2.2Z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <circle cx="16.2" cy="8.8" r="1" fill="currentColor" />
    </svg>
  )
}

export function IconRoute() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <circle cx="6.2" cy="17.6" r="2" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="17.8" cy="6.4" r="2" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M8.2 16.4c1.8-3.2 3.4-4.6 7.4-4.6h1.2" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  )
}

export function IconMore() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <circle cx="6" cy="12" r="1.5" fill="currentColor" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      <circle cx="18" cy="12" r="1.5" fill="currentColor" />
    </svg>
  )
}

export function IconImageOff() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
      <rect x="3.6" y="5.4" width="16.8" height="13.2" rx="2" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="m6 16 3.2-3.4 2.2 2.1 2.4-2.8L18 16M6 6l12 12" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function ScanIconButton({
  label,
  caption,
  onClick,
  disabled,
  children,
  className = '',
}) {
  return (
    <button
      type="button"
      className={`scan-icon-action${caption ? ' scan-labeled-action' : ''} ${className}`.trim()}
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
    >
      <span className="scan-icon-action-glyph">{children}</span>
      {caption ? <span className="scan-icon-action-caption" aria-hidden="true">{caption}</span> : null}
    </button>
  )
}
